/**
 * share.js — nút "copy link" ở chân bài viết.
 *
 * Facebook/LinkedIn dùng URL dựng sẵn ở server nên không cần JS; chỉ nút copy
 * cần can thiệp. Không có JS (hoặc clipboard bị chặn) thì nút vẫn là link tới
 * chính bài viết, người đọc copy tay được.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var buttons = [].slice.call(document.querySelectorAll('[data-share-copy]'));
    if (!buttons.length) return;

    buttons.forEach(function (button) {
        var original = button.getAttribute('aria-label') || '';
        var copied = button.getAttribute('data-share-copied') || 'Link copied';
        var timer;

        function flash() {
            button.classList.add('is-copied');
            button.setAttribute('aria-label', copied);
            window.clearTimeout(timer);
            timer = window.setTimeout(function () {
                button.classList.remove('is-copied');
                button.setAttribute('aria-label', original);
            }, 2000);
        }

        button.addEventListener('click', function (event) {
            var url = button.getAttribute('href') || window.location.href;
            if (!navigator.clipboard || !navigator.clipboard.writeText) return;

            event.preventDefault();
            navigator.clipboard.writeText(url).then(flash, function () {
                window.location.href = url;
            });
        });
    });
})();
